import SettingBtn from "../SettingBtn/SettingBtn";
import { useIntl } from "react-intl";
import styles from "./SettingsList.module.scss";
import { ISettingsListProps } from "./SettingsList.props";

export default function SettingsList({ ...props }: ISettingsListProps) {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.tooltip_content}>
      <SettingBtn isDefault>
        {formatMessage({ id: "machines.add_default_miner" })}
      </SettingBtn>
      {props.list.map((s) => (
        <SettingBtn key={s.cloned_miner} setting={s} />
      ))}
    </div>
  );
}
